import {Box, Container, Typography} from "@mui/material";
import DataFilter from '../../components/DataFilter';
import CardSeguros from "./cardSeguros";
import { categoriaSeguros, dataSeguros } from "../../data/dataSeguros";
import {ScrollStatic} from "../../components/common/ScrollItem";

const Seguros = () => {
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100%",
        backgroundSize: "100% 20%",
        backgroundRepeat: "no-repeat",
        mb: { xs: "5px", sm: "10px" },
        overflow: "auto",
      }}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: { xs: 15 },
          maxWidth: "100% !important",
          pl: "0 !important",
          pr: "0 !important",
        }}
      >
        <ScrollStatic>
          <Typography
            variant="h1"
            align="center"
            sx={{
              width: "100%",
              color: "#194AC1",
            }}
          >
            Seguros
          </Typography>
        </ScrollStatic>

        <ScrollStatic>
          <DataFilter categoriasList={categoriaSeguros} categoriaIgual1="tipo" categoriaIgual2="subtipo" categoriaIgual3="subtipo_1" dataItem={dataSeguros} dataBusqueda="titulo" labelBusqueda={"Buscar seguro"} labelSelect={"Tipo de Seguro"} ComponentView={CardSeguros} GridXs={12} GridSm={12} GridMd={6} GridLg={4} /> 
        </ScrollStatic>
      </Container>
    </Box>
  );
};

export default Seguros;
